require('./_cta.scss')

const CampaignCta = {
    init: function (stickyCTA) {;
      const contactForm = document.querySelector("#contact");
      
      if (!contactForm) {
        stickyCTA.classList.add("sticky-CTA--display-none")
      } else {
        stickyCTA.classList.remove("sticky-CTA--display-none")
      }
    },
  };
  
  export default CampaignCta;